var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.6581C9 15.3145 8.88054 14.9709 8.64081 14.7087L2.9625 8.5L8.64081 2.29126C9.11946 1.76693 9.11946 0.916906 8.64081 0.392577C8.16135 -0.130858 7.38405 -0.130858 6.90459 0.392576L0.358985 7.55066C-0.119662 8.07499 -0.119662 8.92501 0.358985 9.44934L6.90459 16.6074C7.38405 17.1309 8.16134 17.1309 8.64081 16.6074C8.88054 16.3453 9 16.0017 9 15.6581Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackArrow);
export default __webpack_public_path__ + "static/media/ic-back-arrow.0eeae2c71bd2fa5c11835f753e024320.svg";
export { ForwardRef as ReactComponent };